module.exports = __webpack_public_path__ + "static/book-v3-b14d525939db82d09cab8ffb61751d35.png";